import React, { useState } from 'react';
//import { useHistory } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { API_BASE } from "../apiBase";
import { ownerSecretHeader } from '../ownerSecret';

export const EditVspPage = ({ vspToEdit, currentAircraft }) => {
    const rowId = vspToEdit?._id ?? vspToEdit?.id ?? vspToEdit?.item ?? '';

    const [name, setName] = useState(vspToEdit?.name ?? vspToEdit?.item ?? vspToEdit?.id ?? '');
    const [config, setConfig] = useState(vspToEdit?.config ?? vspToEdit?.configuration ?? '');
    const [vs1, setVsp1] = useState(String(vspToEdit?.vsp1 ?? vspToEdit?.vs1 ?? vspToEdit?.Vspeed1 ?? ''));
    const [vs2, setVsp2] = useState(String(vspToEdit?.vsp2 ?? vspToEdit?.vs2 ?? vspToEdit?.Vspeed2 ?? ''));
    const [units, setUnits] = useState(vspToEdit?.units ?? 'MPH');

    const tail = currentAircraft?.tailNumber || "";

    const navigate = useNavigate();

    const editVsp = async () => {
        if (!rowId) {
            alert('Missing row id');
            return;
        }
        if (!tail) {
            alert('Missing aircraft tail');
            return;
        }

        const editedVsp = {
            name: String(name || rowId),
            item: String(name || rowId),
            config: String(config || ''),
            vsp1: Number(vs1),
            vsp2: Number(vs2),
            units: String(units || 'MPH'),
        };

        const url = `${API_BASE}/api/vspeeds?tail=${encodeURIComponent(tail)}&id=${encodeURIComponent(rowId)}`;

        const response = await fetch(
            url,
            {
                method: 'PUT',
                body: JSON.stringify(editedVsp),
                headers: {
                    'Content-Type': 'application/json',
                    ...ownerSecretHeader(tail),
                },
            });

        if (response.status === 200) {
            alert("Successfully edited the vspeed");
        } else if (response.status === 403) {
            alert("You're not authorized to edit this aircraft's vspeeds.");
        } else {
            alert(`Failed to edit vspeed, status code = ${response.status}: ${await response.text()}`);
        }
        navigate('/vsps');
    };

    return (
        <div>
            <p>Edit Vspeeds Page</p>

            <table id="edit-vsp">
                <thead>
                    <tr>
                        <th className='name_box'>name</th>
                        <th className='config_box'>configuration</th>
                        <th className='speed_box'>Vspeed1</th>
                        <th className='speed_box'>Vspeed2</th>
                        <th className='unit_box'>Units</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th className='name_box'>
                            <input type="text" value={name} onChange={e => setName(e.target.value)} />
                        </th>
                        <th className='config_box'>
                            <input type="text" value={config} onChange={e => setConfig(e.target.value)} />
                        </th>
                        <th className='speed_box'>
                            <input type="text" value={vs1} onChange={e => setVsp1(e.target.value)} />
                        </th>
                        <th className='speed_box'>
                            <input type="text" value={vs2} onChange={e => setVsp2(e.target.value)} />
                        </th>
                        <th className='unit_box'>
                            <select value={units} onChange={e => setUnits(e.target.value)}>
                                <option>mph</option>
                                <option>KTS</option>
                                <option>MPH</option>
                            </select>
                        </th>
                    </tr>
                </tbody>

                <button onClick={editVsp}>Save</button>
            </table>
        </div>
    );
}

export default EditVspPage;